import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DomainsService } from 'src/app/shared/services/domains.service';
import { CaptchaComponent } from 'src/app/users/captcha/captcha.component';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-before-login-layout',
	templateUrl: './before-login-layout.component.html',
	styleUrls: ['./before-login-layout.component.scss']
})
export class BeforeLoginLayoutComponent {
	@ViewChild('captchaComponent', { static: false }) captchaComponent: CaptchaComponent;
	page = 'login';

	pagesTitles = {
		login: 'login_register.login_into',
		register: 'login_register.sign_up',
		'forgot-password': 'login_register.forgot_password',
		'reset-password': 'login_register.reset_password',
		contact: 'contact_us.title',
	}

	pagesSubTitles = {
		login: this.translateService.instant('login_register.access_real_time'),
		register: this.translateService.instant('login_register.sign_up_message'),
		'forgot-password': this.translateService.instant('login_register.forgot_password_message'),
		'reset-password': '',
		contact: this.translateService.instant('contact_us.subtitle'),
		'non-confirmed-user-email': this.translateService.instant('contact_us.subtitle'),
		'landing': ''

	}

	isValidEmail = false;
	isSmartTelemetrics = false;
	isFred = false;
	showCaptcha: boolean = false;
	copyrightYear = new Date().getFullYear();
	centralizeTemplate: boolean = false;

	googlePlayAppLink: string = this.domainsService.mobileAppLinks.google_play.iotah;
	appStoreAppLink: string = this.domainsService.mobileAppLinks.app_store.iotah;
	siteName: string = this.translateService.instant('g.smart_telemetrics');
	imageClass: string = 'smart_telemetrics';

	constructor(
		private router: Router,
		private translateService: TranslateService,
		private domainsService: DomainsService,
		private route: ActivatedRoute,
	) {
	}

	yearAge = new Date().getFullYear();
	loginLogo: string = '';

	ngOnInit() {
		this.updatePage();
		this.centralizeTemplate = this.route.snapshot.firstChild.routeConfig?.path == 'landing';
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				if (event.urlAfterRedirects.includes('landing'))
					return this.centralizeTemplate = true;
				return this.centralizeTemplate = false;
			}
			this.updatePage();
		});

		this.updateLoginImage();
		this.pagesSubTitles.contact = `${this.pagesSubTitles.contact} ${this.siteName}.`;
		this.pagesSubTitles.register = `${this.pagesSubTitles.register} ${this.siteName}.`;

		const domainLinks = this.domainsService.getAppLinks();
		this.isSmartTelemetrics = this.domainsService.isSmartTelemetrics;
		this.isFred = this.domainsService.isFred;
		this.googlePlayAppLink = domainLinks.google_play;
		this.appStoreAppLink = domainLinks.app_store;
	}

	updateLoginImage() {
		if(this.domainsService.isChargLink) {
			this.imageClass = 'charglink';
			this.siteName = this.translateService.instant('g.charglink');
			this.loginLogo = '/images/chargLink/charglink-logo.png';
			return
		}

		if(this.domainsService.isBattlink) {
			this.imageClass = 'battlink';
			this.siteName = this.translateService.instant('g.battlink');
			this.loginLogo = '/images/battLink/battlink-logo.png';
			return
		}

		if(this.domainsService.isIotah) {
			this.imageClass = 'iotah';
			this.siteName = this.translateService.instant('g.iotah');
			this.loginLogo = '/images/logo-v1.png';
			return
		}

		if(this.domainsService.isFred) {
			this.imageClass = 'fred';
			this.siteName = this.translateService.instant('g.fred');
			this.loginLogo = '/images/fred/logo-2.png';
			return;
		}

		this.imageClass = 'smart_telemetrics';
		this.siteName = this.translateService.instant('g.smart_telemetrics');
		this.loginLogo = '/images/smartTelemetrics/logo.png';
		return;
	}

	updatePage() {
		this.page = this.router.url.split('/')[1] || 'login';
	}
}
